import { useEffect } from 'react'
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react'
import type { ToastProps } from './Toast.types'

export function Toast({ id, message, type, onClose }: ToastProps) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(id)
        }, 5000)
        return () => clearTimeout(timer)
    }, [id, onClose])

    const icons = {
        success: <CheckCircle className="w-5 h-5 text-green-500" />,
        error: <AlertCircle className="w-5 h-5 text-red-500" />,
        info: <Info className="w-5 h-5 text-blue-500" />,
    }

    return (
        <div className="flex items-center gap-3 px-4 py-3 rounded-full border border-border-light/30 dark:border-border-dark/30 bg-surface-light/95 dark:bg-surface-dark/95 shadow-lg backdrop-blur-md animate-in slide-in-from-bottom-5 fade-in duration-300">
            {icons[type]}
            <p className="text-text-primary text-sm font-medium truncate max-w-xs">{message}</p>
            <button
                onClick={() => onClose(id)}
                className="ml-1 text-text-secondary hover:text-text-primary transition-colors flex-shrink-0"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    )
}
